import { MasterClassStudioQuery } from '@/generated/graphql'
import Image from 'next/image'

export type StudioLesson = NonNullable<
  NonNullable<MasterClassStudioQuery['streams']>['items']
>[number]

type Props = {
  lesson: StudioLesson
}

const StudioCard = ({ lesson }: Props) => {
  return (
    <article className="flex flex-col overflow-hidden rounded-md bg-white shadow-sm border border-gray-200">
      <div className="relative w-full aspect-[16/9]">
        <Image
          src={lesson.thumbnailSrc ?? ''}
          alt={lesson.name || 'Studio Lesson'}
          fill
          className="object-cover"
        />
      </div>

      <div className="flex flex-1 flex-col px-6 py-5">
        <h3 className="text-xl font-semibold leading-snug">{lesson.name}</h3>

        <p className="mt-2 text-gray-500">
          {lesson.creators?.[0]?.name || 'Unknown'}
        </p>
      </div>
    </article>
  )
}

export default StudioCard
